import { Breadcrumbs } from '@/components/Breadcrumbs/Breadcrumbs';
import { Container } from '@/components/Container/Container';
import { LoginForm } from '@/components/Forms/LoginForm/LoginForm';
import { PublicPage } from '@/components/Page/PublicPage';
import { ESize } from '@/models/enums';
import { NextPage } from 'next';

const LoginNextPage: NextPage = () => {
  return (
    <PublicPage
      meta={{
        seoDescription:
          'Log in to your account securely to access personalized features, manage your settings, and stay connected. Quick and easy login for a seamless experience.',
        seoTitle: 'Secure Login | Access Your Account',
      }}
      title="Login"
    >
      <Container additionalClassNames="py-12" size={ESize.XS}>
        <div className="mb-2">
          <Breadcrumbs items={[{ content: <span>Login</span>, key: 'Login' }]} />
        </div>
        <h1 className="color-black text-uppercase mb-4">Login</h1>
        <p className="mb-8">Login to continue</p>
        <LoginForm />
      </Container>
    </PublicPage>
  );
};

export default LoginNextPage;
